import React, {useState, useContext} from "react";
// リダイレクト(認証期間切れの場合にリダイレクトするため useHistory)
import {Link, useLocation, useHistory} from "react-router-dom";

import Fab from "@material-ui/core/Fab";
import AddIcon from '@material-ui/icons/Add';
import Tooltip from '@material-ui/core/Tooltip';

import GenericTemplate from "../../templates/GenericTemplate";
import {apollo_useStyles} from "../../atom/Apollo_styles";
import {ApolloMessage, CustomizedSnackbars} from "../../atom/Apollo_Mesasge";
import {
  apollo_users_path,
  get_apollo_roles_by_accountgroup_path,
} from "../../atom/Apollo_links";
import {ApolloBreadcrumbs} from "../../atom/Apollo_Breadcrumbs";
import {APOLLO_GROUP_ADMIN, APOLLO_PROFILE_SYSTEM_ADMIN, ApolloPageUsagePermission} from "../../atom/Apollo_Authorization";
import {PageUser, AccountGroupRoles} from "./UserModel";
import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";
import {ApolloTabsVariable, ApolloTabPanel} from "../../atom/Apollo_TabsVariable";
import ApolloUserTop from "../../organism/USER/Apollo_UserTop";
import ApolloRoleTop from "../../organism/USER/Apollo_RoleTop";
// メッセージ定義
import {
  GetMessage,
  UI_USER_LIST,
} from "../../atom/Apollo_MesasgeDefinition";
// 認証期間切れの処理
import {ApolloExpired} from "../../atom/Apollo_Expired";

const UserPage: React.FC = () => {
  const {data, setmsg} = useContext(ApolloMessage);
  const classes = apollo_useStyles();
  const [tabstate, setTabstate] = useState(0);
  const [users, setUsers] = React.useState<PageUser[]>([]);
  const [accountGroupRoles, setAccountGroupRoles] = React.useState<AccountGroupRoles[]>([]);
  // リダイレクト(認証期間切れの場合にリダイレクトするため)
  const history = useHistory();

  const tablabel = ["ユーザー一覧", "ロール一覧"]

  let query1 = new URLSearchParams(useLocation().search);
  let queryType = query1.has("type") ? query1.get("type") : "";

  React.useEffect(() => {
    setmsg({
      type: "loading",
      payload: {
        ...data,
        loading: true
      }
    })

    if (tabstate === 0 || tabstate === 1) {
      // ユーザー一覧
      const userUrl = `${apollo_users_path}`;
      ApolloAxios.get(userUrl).then((response2) => {
        // ユーザー情報セット
        setUsers(response2.data.result);
        setmsg({
          type: "loading",
          payload: {
            ...data,
            loading: false
          }
        })
      }).catch((err) => {
        // 認証期間切れ判定とエラーメッセージ表示
        if (!ApolloExpired(err, GetMessage("0",UI_USER_LIST,"E","0"), data, setmsg, history)) {
          // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
        }
      });
    }
    if (tabstate === 1) {
      // ロール一覧(アカウントグループ)
      const roleUrl = `${get_apollo_roles_by_accountgroup_path}/0`;
      ApolloAxios.get(roleUrl).then((response) => {
        // ロール情報セット
        setAccountGroupRoles(response.data.result);
        setmsg({
          type: "loading",
          payload: {
            ...data,
            loading: false
          }
        })
      }).catch((err) => {
        // 認証期間切れ判定とエラーメッセージ表示
        if (!ApolloExpired(err, GetMessage("0",UI_USER_LIST,"E","1"), data, setmsg, history)) {
          // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
        }
      });
    }
  }, [tabstate]);
 
  return (
    <GenericTemplate title="">
      <ApolloPageUsagePermission role={APOLLO_GROUP_ADMIN} profile={APOLLO_PROFILE_SYSTEM_ADMIN}>
      <ApolloBreadcrumbs bread_no={queryType === "ag" ? 57 : 28} zeusaccountid={0} zeuscampaignid={0} adgroupid={0}
                        adid={0} query={""} platform={""}/>
      <ApolloTabsVariable value={tabstate} setValue={setTabstate} tablabel={tablabel}/>
        <Tooltip title="ユーザー新規作成" placement="bottom">
          <Link to="/useredit/0" className={classes.link}>
            <Fab size="small" color="primary" aria-label="add" style={{marginTop: "10px", marginBottom: "10px"}}>
              <AddIcon/>
            </Fab>
          </Link>
        </Tooltip>

        <ApolloTabPanel value={tabstate} index={0}>
          <ApolloUserTop rows={users}/>
        </ApolloTabPanel>

        <ApolloTabPanel value={tabstate} index={1}>
          <ApolloRoleTop rows={users} accountgroupRoles={accountGroupRoles}/>
        </ApolloTabPanel>
      </ApolloPageUsagePermission>
      <CustomizedSnackbars/>
    </GenericTemplate>
  );
};

export default UserPage;
